import { DocumentTemplateVersionDTO } from "src/models/document-templates";
import { DocumentTemplateVersionSTO } from "src/models/document-templates/document-template-version/document-template-version-sto";
import { BaseApiService } from "../base";

export class DocumentTemplateVersionApiService extends BaseApiService<
  DocumentTemplateVersionDTO,
  DocumentTemplateVersionSTO
> {
  constructor() {
    super({
      servicePath: "/DocumentTemplate",
      loadItemsPath: "/GetDocumentTemplateVersions",
      saveItemsPath: "/SaveDocumentTemplateVersions",
    });
  }
}
